module.exports = __webpack_public_path__ + "/images/monitorizacion-precios-wishlist-EN.3326c55.png";